export default "__VITE_ASSET__Dd1aneKX__"